import { Global } from '@emotion/react';

const CustomScrollbar = () => {
  return (
    <Global
      styles={{
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: '#888 #f1f1f1',
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          borderRadius: '12px', // Set border radius to 12px
        },
        '*::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '12px', // Set border radius to 12px
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '12px', // Set border radius to 12px
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
      }}
    />
  );
};

export default CustomScrollbar;
